import React, { Fragment } from 'react';
import ActionBarMobile from './components/ActionBarMobile';
import FileTable from './components/file-table/FileTable';

const Secondary = () => {
	return (
		<Fragment>
			<div className="secondary-content">
				<FileTable className="filetable" />
			</div>
			<ActionBarMobile />
		</Fragment>
	);
};

export default Secondary;



// WEBPACK FOOTER //
// ./src/SecondaryMobile.js